require('babel-polyfill');



// WEBPACK FOOTER //
// ./src/shared/polyfill.js